"use client";
import { type Url } from "next/dist/shared/lib/router/router";
import { useEffect, useState } from "react";
import { useThirdPartyURLsContext } from "@/context/thirdPartyURLs";
import { parseUTMParameters } from "@/utils/utm/parseUTMParameters";

export function useGetDecoratedURI(currentUri: string): Url {
  const thirdPartyUrls = useThirdPartyURLsContext();
  const [decoratedUrl, setDecoratedUrl] = useState<string>(currentUri);

  useEffect(() => {
    const utmParams = parseUTMParameters();

    const thirdPartyUrl = thirdPartyUrls.find(({ url }) =>
      currentUri.includes(url),
    );

    if (thirdPartyUrl) {
      const { url, formName, formType } = thirdPartyUrl;

      const urlObj = new URL(url);

      if (formName) {
        urlObj.searchParams.set("formName", formName);
      }

      if (formType) {
        urlObj.searchParams.set("formType", formType);
      }

      utmParams.forEach(([key, value]) => {
        urlObj.searchParams.set(key, value);
      });

      setDecoratedUrl(urlObj.toString());
    }
  }, [thirdPartyUrls, currentUri]);

  return decoratedUrl;
}
